import type { ReactNode, FC } from 'react';
import { useMemo } from 'react';
import type { ViewStyle } from 'react-native';
import { StyleSheet, View } from 'react-native';
import type { CardProps } from 'react-native-paper';
import { Card, Text } from 'react-native-paper';

import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    content: {
      gap: 20,
      paddingVertical: 32,
      alignItems: 'center',
      justifyContent: 'center'
    },
    description: { textAlign: 'center', color: theme.colors.onSurfaceVariant }
  });

type Props = {
  style?: ViewStyle;
  backgroundColor?: string;
  description: string;
  mode?: CardProps['mode'];
  footer?: ReactNode;
};

export const EmptyCard: FC<Props> = ({
  style,
  backgroundColor,
  description,
  mode = 'elevated',
  footer
}) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <View style={style}>
      <Card
        style={{
          backgroundColor:
            backgroundColor ?? theme.colors.surfaceContainerLowest
        }}
        mode={mode}
      >
        <Card.Content style={styles.content}>
          <Text variant="titleMedium" style={styles.description}>
            {description}
          </Text>
          {footer}
        </Card.Content>
      </Card>
    </View>
  );
};
